const state = {
  // Desktop sidebar collapsed to the icon-only rail.
  sidebarCollapsed: false,
};

const getters = {
  sidebarCollapsed: (state) => state.sidebarCollapsed,
};

const actions = {
  toggleSidebar({ commit }) {
    commit("setSidebarCollapsed");
  },
  setSidebarCollapsed({ commit }, value) {
    commit("setSidebarCollapsed", value);
  },
};

const mutations = {
  setSidebarCollapsed: (state, value) =>
    (state.sidebarCollapsed =
      typeof value === "boolean" ? value : !state.sidebarCollapsed),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
